export default __webpack_public_path__ + "static/media/stack.273dfe5a.svg";